// Override the deprecated media query detection before perfect-scrollbar loads
const originalMatchMedia = window.matchMedia;

window.matchMedia = function (query) {
  // If the query contains -ms-high-contrast, replace it with forced-colors
  if (query.includes("-ms-high-contrast")) {
    const forcedColorsQuery = query.replace(
      /-ms-high-contrast/g,
      "forced-colors",
    );
    return originalMatchMedia.call(this, forcedColorsQuery);
  }
  return originalMatchMedia.call(this, query);
};

// Also override the CSS.supports method if it exists
if (window.CSS && window.CSS.supports) {
  const originalSupports = window.CSS.supports;
  window.CSS.supports = function (property, value) {
    // If checking for -ms-high-contrast support, check for forced-colors instead
    if (property === "-ms-high-contrast" || value === "-ms-high-contrast") {
      return originalSupports.call(this, "forced-colors", "active");
    }
    return originalSupports.call(this, property, value);
  };
}

export default function setupPerfectScrollbarOverride() {
  // This function can be called to ensure the override is applied
  console.log("Perfect Scrollbar deprecation override applied");
}
